// extracted by mini-css-extract-plugin
module.exports = {"list":"MessengerFriendsSearch_list__3mBRd"};